import { useLang } from "hooks/useLang"
import { IFinalEvent } from "types/event"
import ShareAndLike from "components/EventDetailsPage/ShareAndLike"
import useWindowSize from "hooks/useWindowSize"
import dayjs from "dayjs"
import { OptimizedEvent } from "types/optimizedEvent"

interface IProps {
    event: IFinalEvent | OptimizedEvent
    className?: string
}

const EventHeader = ({ event }: IProps) => {
    const { multiLangVars, isAr, t } = useLang()
    const title = event?.[multiLangVars("title") as "ar_title" | "en_title"]
    const { isDesktop } = useWindowSize()
    if (isDesktop) {
        return (
            <>
                <div className="flex flex-col lg:flex-row border border-[#B5B5B5] dark:border-white/50 rounded-md">
                    <div
                        className={`col flex lg:border-none px-2 py-2 lg:py-8 lg:w-[80%] lg:order-2`}
                    >
                        <div
                            className={`relative col flex flex-col items-center lg:items-start justify-center w-full px-2 lg:pl-10 lg:w-[160%]`}
                        >
                            <div
                                className={`small-border-element absolute top-[17%] bottom-[17%] ${isAr ? "left-0" : "right-0"} w-px bg-[#B5B5B5]  dark:bg-white/50 hidden lg:block`}
                            ></div>
                            <h1 className="text-xl lg:text-2xl font-bold  text-centre">
                                {title}
                            </h1>
                        </div>
                        <div className="hidden md:flex col flex-col items-center justify-center flex lg:px-2 lg:w-[50%] ">
                            <ShareAndLike
                                event={event as IFinalEvent}
                                iconsSize={27}
                                className="dark:text-white text-black"
                            />
                        </div>
                    </div>
                    <div
                        className={`col flex items-center justify-center px-2 pb-4 lg:py-8 lg:w-[20%] lg:border-${isAr ? "l" : "r"}  lg:border-white/50 lg:order-1 `}
                    >
                        <div className="relative col flex flex-col items-center justify-center w-[50%] px-2 ">
                            <div
                                className={`small-border-element absolute top-0 bottom-0 ${isAr ? "left-0" : "right-0"} w-px bg-[#B5B5B5] dark:bg-white/50`}
                            ></div>
                            <span className="text-md lg:text-lg leading-5">
                                {dayjs(event?.event_date?.starting_date).format(
                                    "D"
                                )}
                            </span>
                            <span className="text-xs font-light">
                                {t(dayjs(event?.event_date?.starting_date).format(
                                    "MMM"
                                ))}
                            </span>
                        </div>

                        <div className="col flex flex-col items-center w-full px-2">
                            <span className="text-md md:text-lg">
                                {t(dayjs(event?.event_date?.starting_date).format(
                                    "dddd"
                                ))}
                            </span>
                            <span className="text-xs font-light">
                                {dayjs(event?.event_date?.starting_date).format(
                                    "hh:mm"
                                )}
                                {" "}
                                {t(dayjs(event?.event_date?.starting_date).format(
                                    "A"
                                ))}
                            </span>
                        </div>
                    </div>
                </div>

                {/* {!isDesktop && (
                    <div className="flex justify-start mt-4">
                        <ShareAndLike
                            event={event as IFinalEvent}
                            iconsSize={27}
                            className="dark:text-white text-black"
                        />
                    </div>
                )} */}
            </>
        )
    }
    return (

        <div className="w-full mt-8 min-h-[100px] rounded-md border-white border-[1px] p-4 items-center justify-center flex flex-col items-between">
            <div className="flex-1 flex">
                <span className="text-[20px] text-center">{title}</span>
            </div>
            <div className="flex-1 flex flex-row items-between  w-full items-center justify-center">


                <div className="flex flex-col flex-1 items-center py-1 relative">
                    <span className="text-md lg:text-lg leading-5">
                        {dayjs(event?.event_date?.starting_date).format(
                            "D"
                        )}
                    </span>
                    <span className="text-xs font-light">
                        {t(dayjs(event?.event_date?.starting_date).format(
                            "MMM"
                        ))}
                    </span>
                    <div
                        className={`small-border-element absolute top-0 bottom-0 ${isAr ? "left-0" : "right-0"} w-px bg-[#B5B5B5] dark:bg-white/50`}
                    ></div>
                </div>


                <div className="flex flex-col flex-1 items-center relative">
                    <span className="text-md md:text-lg">
                        {t(dayjs(event?.event_date?.starting_date).format(
                            "dddd"
                        ))}
                    </span>
                    <span className="text-xs font-light">
                        {dayjs(event?.event_date?.starting_date).format(
                            "hh:mm"
                        )}
                        {" "}
                        {t(dayjs(event?.event_date?.starting_date).format(
                            "A"
                        ))}
                    </span>
                    <div
                        className={`small-border-element absolute top-0 bottom-0 ${isAr ? "left-0" : "right-0"} w-px bg-[#B5B5B5] dark:bg-white/50`}
                    ></div>
                </div>

                <div className="flex flex-col flex-1 items-center">
                    <ShareAndLike
                        event={event as IFinalEvent}
                        iconsSize={20}
                        className="dark:text-white text-black"
                    />
                </div>
            </div>
        </div>
    )


}

export default EventHeader
